module.exports = __webpack_public_path__ + "img/ldl.9edd3d3f.png";